import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistStore,
  persistReducer,
  PersistConfig,
} from 'redux-persist';

import storage from 'redux-persist/es/storage';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

import { eventsApi } from '../events/eventsApi';
import { metabaseApi } from './metabase/metabaseApi';
import { goalpostApi } from '../goalpost/goalpostApi';

const middleware = [metabaseApi.middleware, eventsApi.middleware, goalpostApi.middleware];

const persistConfig: PersistConfig<any> = {
  key: 'root',
  storage: storage,
  whitelist: [],
};

const rootReducer = combineReducers({
  [eventsApi.reducerPath]: eventsApi.reducer,
  [metabaseApi.reducerPath]: metabaseApi.reducer,
  [goalpostApi.reducerPath]: goalpostApi.reducer,
});

const persistedReducer = persistReducer<any, any>(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(middleware),
  devTools: true,
});

// export type RootState = ReturnType<typeof store.getState>;

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const persistor = persistStore(store);
